export function getNestedValue(obj: any, path: string) {
  return path
    .split(/[.[\]]+/)
    .filter(Boolean)
    .reduce((acc, key) => acc && acc[key], obj)
}
